export default __webpack_public_path__ + "static/media/icon_ovm_graph.de70f93e.svg";